import script from "./ToggleButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToggleButton.vue?vue&type=script&setup=true&lang=ts"

import "./ToggleButton.vue?vue&type=style&index=0&id=599ab48a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-599ab48a"]])

export default __exports__